import { Card, Typography } from '@mui/material';

export const ReferralListEmpty = () => {
  return (
    <Card
      sx={{
        flex: 1,
        padding: { xs: 3.5, sm: 3 },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '250px',
      }}
    >
      <Typography
        variant="h4"
        maxWidth={380}
        textAlign="center"
        className="secondary"
        fontSize={{ xs: '18px', md: '24px' }}
      >
        No one has applied your referral code yet
      </Typography>
    </Card>
  );
};
